import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/motion/Reveal";
import { ContactForm } from "@/components/ContactForm";
import { BUSINESS } from "@/data/content";

const info = [
  { icon: Phone, label: "Call us", value: BUSINESS.phone, href: BUSINESS.phoneHref },
  { icon: Mail, label: "Email us", value: BUSINESS.email, href: BUSINESS.emailHref },
  { icon: MapPin, label: "Service area", value: `${BUSINESS.location} & surrounding areas` },
  { icon: Clock, label: "Response time", value: "Within 24 hours" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader
        overline="Contact"
        titleLines={["Let's grow", "your business."]}
        subtitle="Tell us a little about your business and what you're hoping to accomplish. We'll follow up within 24 hours — no pressure, no jargon."
      />

      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
                Talk to a real person.
              </h2>
              <p className="mt-4 text-ink/60">
                Prefer to call? We'd love to hear about your business directly. Reach out
                any way that's easiest for you.
              </p>
              <div className="mt-10 space-y-4">
                {info.map((it) => {
                  const Comp = it.href ? "a" : "div";
                  return (
                    <Comp
                      key={it.label}
                      href={it.href}
                      data-testid={`contact-info-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="flex items-center gap-4 rounded-2xl border border-black/10 bg-paper p-5 transition-colors hover:border-brand"
                    >
                      <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand/10 text-brand">
                        <it.icon className="h-5 w-5" />
                      </span>
                      <span>
                        <span className="block font-mono text-xs uppercase tracking-[0.15em] text-ink/45">
                          {it.label}
                        </span>
                        <span className="block font-bold text-ink">{it.value}</span>
                      </span>
                    </Comp>
                  );
                })}
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="rounded-2xl border border-black/10 bg-paper p-6 sm:p-10">
                <h3 className="font-display text-2xl font-bold tracking-tight">
                  Request your free quote
                </h3>
                <p className="mt-2 text-sm text-ink/55">
                  Fields marked with * are required.
                </p>
                <div className="mt-8">
                  <ContactForm />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
